module.exports = require('./dist/cleave-react-node.js');



//////////////////
// WEBPACK FOOTER
// ./~/cleave.js/react.js
// module id = 247
// module chunks = 35783957827783